var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51436 6.15865C3.19689 6.33502 3 6.66964 3 7.03281V11.6715C3 15.3032 4.96892 18.6494 8.14357 20.4131L10.5144 21.7302C10.8164 21.898 11.1836 21.898 11.4856 21.7302L13.8564 20.4131C17.0311 18.6494 19 15.3032 19 11.6715V7.03281C19 6.66964 18.8031 6.33502 18.4856 6.15865L11.4856 2.26976C11.1836 2.10197 10.8164 2.10197 10.5144 2.26976L3.51436 6.15865ZM8.96967 12.5304L10.9697 14.5304C11.2626 14.8232 11.7374 14.8232 12.0303 14.5304L16.0303 10.5304C16.3232 10.2375 16.3232 9.76259 16.0303 9.46969C15.7374 9.1768 15.2626 9.1768 14.9697 9.46969L11.5 12.9394L10.0303 11.4697C9.73744 11.1768 9.26256 11.1768 8.96967 11.4697C8.67678 11.7626 8.67678 12.2375 8.96967 12.5304Z",
    fill: "#B8E9C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/ShieldTick.ba3edd4422e75620d7c665e4c7a9e394.svg";
export { ForwardRef as ReactComponent };